<template>
  <div class="authorization PuHui">
    <div class="top">
      <div class="top-inner">
        <span class="title-1">宁东工业超市</span>
        <i class="line"></i>
        <span class="title-2">服务授权</span>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div>
          <div class="logo">
            <img src="./authorization/logo.png" alt="" />
          </div>
          <div class="left-title">欢迎访问 中控SCADA</div>
          <div class="left-text">授权后，该应用将获得以下权限</div>
          <div class="left-title">· 获取你的手机号码和登录名</div>
        </div>
      </div>
      <div class="right">
        <div>
          <div class="right-title">通过授权，SCADA可以获取你的部分个人信息</div>
          <div class="right-head">
            <img
              :src="
                userInfo.headPhoto ||
                'https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/wms/plantmate_logo.png'
              "
              alt=""
            />
            <div>{{ userInfo.userName }}</div>
          </div>
          <div class="right-text">
            <el-checkbox class="check" v-model="checked"></el-checkbox>
            <span>已阅读并同意：</span>
            <a href="https://www.plantmate.com/static/plantmate-user-auth-agreement.html" target="_blank">《用户授权协议》</a>
          </div>
          <div
            class="right-btn"
            :class="{ active: checked }"
            @click="getAuthCode"
          >
            登录
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      checked: false,
      userInfo: {}
    }
  },
  created () {
    // 未登录
    if (!getAccessToken()) {
      this.$router.push({
        name: 'login'
      })
    }
    this.$http
      .get('/front/consumer/usercenter/custUserCenterInfo', {
        params: {
          appCode: 'PLANTMATE_OFFICIAL'
        }
      })
      .then(({ data: res }) => {
        if (res.code !== 0) {
          return false
        }
        this.userInfo = res.data.userInfo
      })
      .catch(() => {})
  },
  methods: {
    getAuthCode () {
      if (!this.checked) {
        return
      }
      const redirectUri = this.$route.query.redirect_uri
      const url = `/inter/thirdPartyAuth/getAuthCode?client_id=SCADA&redirect_uri=${redirectUri}`
      this.$http.get(url).then(({ data: res }) => {
        if (res.code === 0 && res.data) {
          window.location.replace(`${redirectUri}?code=${res.data.code}`)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.authorization {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: url(./authorization/bg.png) no-repeat;
  background-size: 100% 100%;
}
.top {
  height: 92px;
  background: url(./authorization/top.png) no-repeat;
  background-size: 100% 100%;
  padding: 21px 21px 21px 32px;
  .top-inner {
    display: flex;
    align-items: center;
  }
  .title-1 {
    font-size: 40px;
    font-weight: bold;
    line-height: normal;
    color: #2a54d1;
  }
  .line {
    width: 0;
    height: 30px;
    border: 1px solid #969899;
    margin: 0 28px;
  }
  .title-2 {
    font-size: 22px;
    font-weight: 900;
    color: #1a1a1a;
  }
}
.content {
  flex: 1;
  display: flex;
  .left {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logo {
      padding-bottom: 30px;
      img {
        display: block;
        width: 58.2%;
      }
    }
    .left-title {
      font-size: 30px;
      font-weight: bold;
      margin: 20px 0;
      color: #1a1a1a;
    }
    .left-text {
      font-size: 24px;
      font-weight: normal;
      color: #646566;
    }
  }
  .right {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
    .right-title {
      font-size: 16px;
      font-weight: bold;
      color: #646566;
    }
    .right-head {
      padding: 48px 0 54px 0;
      img {
        width: 148px;
        height: 148px;
        display: block;
        border-radius: 12px;
        margin: 0 auto;
      }
      div {
        font-size: 16px;
        font-weight: bold;
        color: #646566;
        text-align: center;
        padding-top: 12px;
      }
    }
    .right-text {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #808080;
      .check {
        margin-right: 10px;
      }
      a {
        color: #1d65a8;
      }
    }
  }
}
.right-btn {
  margin-top: 24px;
  width: 432px;
  height: 62px;
  line-height: 62px;
  border-radius: 28px;
  background: #e1e3e5;
  text-align: center;
  color: #969899;
  &.active {
    background: #1d65a8;
    color: #fff;
  }
}
</style>
